import React, { useState, useEffect } from 'react';
import HighScoresTable from './HighScoresTable';

const HighScores = ({ connectionUrl }) => {
  const [highScores, setHighScores] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchHighScores = async () => {
      setLoading(true);
      setError(null);
      
      try {
        const isDevelopment = process.env.NODE_ENV === 'development';
        let scoresUrl;
        
        if (connectionUrl === '/' || connectionUrl === '') {
          scoresUrl = isDevelopment ? 'http://localhost:4000/highscores' : '/highscores';
        } else {
          const baseUrl = connectionUrl.endsWith('/') ? connectionUrl.slice(0, -1) : connectionUrl;
          scoresUrl = `${baseUrl}/highscores`;
        }
        
        const response = await fetch(scoresUrl, {
          method: 'GET',
          headers: {
            'Accept': 'application/json',
          },
        });
        
        if (response.ok) {
          const data = await response.json();
          if (data.success && data.scores) {
            // Transform MongoDB documents to match EndGameSummaryTable format
            const transformedScores = data.scores.map((score, index) => ({
              name: score.name || 'Unknown',
              position: index + 1, // Rank by net worth order
              netWorth: score.netWorth || 0,
              cash: score.cash || 0,
              stockCount: score.stockCount || 0,
              color: score.color || null,
              emoji: score.avatar || '🙂',
              sharesPurchased: score.sharesPurchased || 0,
              sharesSold: score.sharesSold || 0,
              indexesPurchased: score.indexesPurchased || 0,
              indexesSold: score.indexesSold || 0,
              biggestSell: score.biggestSell ?? 0,
              biggestGain: score.biggestGain ?? 0,
              numPlayers: score.numPlayers || 0,
              numRounds: score.numRounds || 0
            }));
            setHighScores(transformedScores);
          }
        } else {
          setError('Failed to load high scores');
        }
      } catch (err) {
        console.error('[HighScores] Error fetching high scores:', err);
        setError('Unable to load high scores');
      } finally {
        setLoading(false);
      }
    };

    fetchHighScores();
    
    // Refresh every 30 seconds
    const interval = setInterval(fetchHighScores, 30000);
    
    return () => clearInterval(interval);
  }, [connectionUrl]);

  if (loading) {
    return (
      <div className="highscores-container">
        <div className="highscores-header">
          <h2>🏆 High Scores</h2>
        </div>
        <div className="highscores-loading">
          Loading high scores...
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="highscores-container">
        <div className="highscores-header">
          <h2>🏆 High Scores</h2>
        </div>
        <div className="highscores-error">
          {error}
        </div>
      </div>
    );
  }

  if (highScores.length === 0) {
    return (
      <div className="highscores-container">
        <div className="highscores-header">
          <h2>🏆 High Scores</h2>
        </div>
        <div className="highscores-empty">
          No high scores yet. Be the first to set a record!
        </div>
      </div>
    );
  }

  return (
    <div className="highscores-container">
      <div className="highscores-header">
        <h2>🏆 High Scores</h2>
        <p className="highscores-subtitle">
          Top {highScores.length} players by net worth
        </p>
      </div>
      <HighScoresTable rows={highScores} />
    </div>
  );
};

export default HighScores;

